var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVkColorLightPadding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 50,
    viewBox: "0 0 200 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "VK"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vk-color"
  }, /*#__PURE__*/React.createElement("g", {
    id: "VK.com-logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M94.1733 4H105.827C116.467 4 119 6.53333 119 17.1733V28.8267C119 39.4667 116.467 42 105.827 42H94.1733C83.5333 42 81 39.4667 81 28.8267V17.1733C81 6.53333 83.5333 4 94.1733 4Z",
    fill: "#5181B8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M112.119 17.0915C112.295 16.5044 112.119 16.073 111.281 16.073H108.51C107.806 16.073 107.481 16.4457 107.305 16.8566C107.305 16.8566 105.896 20.2912 103.9 22.5222C103.254 23.1679 102.96 23.3734 102.608 23.3734C102.432 23.3734 102.177 23.1679 102.177 22.5809V17.0915C102.177 16.387 101.973 16.073 101.385 16.073H97.0313C96.5911 16.073 96.3263 16.4 96.3263 16.7099C96.3263 17.3778 97.3243 17.5318 97.4272 19.4105V23.4909C97.4272 24.3855 97.2656 24.5477 96.9133 24.5477C95.974 24.5477 93.6891 21.0978 92.3339 17.1502C92.0683 16.3829 91.802 16.073 91.0938 16.073H88.323C87.5313 16.073 87.373 16.4457 87.373 16.8566C87.373 17.5905 88.3124 21.2306 91.7469 26.0448C94.0365 29.3325 97.2625 31.1147 100.198 31.1147C101.959 31.1147 102.177 30.7188 102.177 30.037V27.5522C102.177 26.7605 102.344 26.6025 102.902 26.6025C103.313 26.6025 104.017 26.808 105.661 28.3932C107.54 30.2719 107.85 31.1147 108.906 31.1147H111.677C112.469 31.1147 112.865 30.7188 112.636 29.9377C112.386 29.1591 111.489 28.0296 110.299 26.6906C109.653 25.9273 108.685 25.1054 108.391 24.6944C107.98 24.1661 108.098 23.9312 108.391 23.4615C108.391 23.4615 111.767 18.706 112.119 17.0915Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVkColorLightPadding);
export default __webpack_public_path__ + "static/media/vk-color-light-padding.2aa1411aed1003ddece5260154a1b07f.svg";
export { ForwardRef as ReactComponent };